import React, { useEffect, useState } from "react"
import { Switch, Route, Redirect, useLocation } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import { focusHandling } from "cruip-js-toolkit"
import "./charts/ChartjsConfig"

// Import pages
import Login from './pages/Login'
import Users from './pages/Users'
import Orders from './pages/Orders'
import NewOrder from './pages/NewOrder'
import AddToBill from './pages/AddToBill'
import Station from './pages/Station'
import Stations from './pages/Stations'
import Inventory from './pages/Inventory'
import ItemTimeline from './pages/ItemTimeline'
import Requests from "./pages/Requests"
import Invoices from "./pages/Invoices"
import SalesByItem from "./pages/SalesByItem"
import OutInvoices from "./pages/OutInvoices"
import SaleItems from "./pages/SaleItems"
import Rooms from "./pages/Rooms"
import Store from "./pages/Store"
import Transactions from "./pages/Transactions"
import ItemGroups from "./pages/ItemGroups"
import Printers from "./pages/Printers"
import Tables from "./pages/Tables"

import { usePet } from "./modules"

import { setparams, setuser } from "./store/actions"

// Import partial components
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import Receive from './components/resusable/receive'
import LockSession from "./components/modals/lockSession"

import './App.css'
import './css/style.scss'

const Main = () => {
    const [lock, setLock] = useState(false)
    const [sidebarOpen, setSidebarOpen] = useState(false)

    const { params } = useSelector(state => state.application)
    
    const dispatch = useDispatch()

    let timer

    const lockSession = () => {
        clearTimeout(timer)

        document.onmousemove = null
        document.onkeydown = null

        sessionStorage.removeItem('token')
        setLock(true)
    }

    const resetTimer = () => {
        setLock(false)
        clearTimeout(timer)

        timer = setTimeout(lockSession, (params?.timeOut ? params.timeOut : 20) * 60000)
        
        document.onmousemove = resetTimer

        document.onkeydown = e => {
            if (e.altKey && e.key === 'L') {
                lockSession()
            } else {
                resetTimer()
            }
        }
    }

    const onComplete = ({ data }) => {
        dispatch(setuser(data))
        resetTimer()
    }

    const [{ loading, error }] = usePet('me', {}, { notify: true, callback: onComplete, logOutOnError: true })

    usePet('itemGroups', {}, { notify: true, callback: ({ data }) => {
        for (let group of data)
            if (group.printer)
                localStorage.setItem(group.name, group.printer.name)
    }, logOutOnError: true })

    return (
        <Receive
            error={error}
            loading={loading}
            progress>
            <div className="flex h-screen overflow-hidden">
                <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
                    <Header lockSession={ lockSession } sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                    <main>
                        <Switch>
                            {/* <Route exact path="/app">
                                <Dashboard />
                            </Route> */}
                            <Route path="/app/bills">
                                <Orders />
                            </Route>
                            {/* <Route exact path="/app/bills/new">
                                <NewOrder />
                            </Route>
                            <Route exact path="/app/bills/add/:id">
                                <AddToBill />
                            </Route> */}
                            <Route exact path="/app/stations">
                                <Stations />
                            </Route>
                            <Route exact path="/app/stations/:id">
                                <Station />
                            </Route>
                            <Route exact path="/app/transactions">
                                <Transactions />
                            </Route>                            
                            <Route exact path="/app/users">
                                <Users />
                            </Route>
                            <Route exact path="/app/received-invoices">
                                <Invoices />
                            </Route>
                            <Route exact path="/app/invoices">
                                <OutInvoices />
                            </Route>
                            <Route exact path="/app/sales">
                                <SalesByItem />
                            </Route>
                            <Route path="/app/rooms">
                                <Rooms />
                            </Route>
                            <Route path="/app/inventory">
                                <Store />
                            </Route>
                            <Route exact path="/app/saleitems">
                                <SaleItems />
                            </Route>
                            <Route exact path="/app/requests">
                                <Requests />
                            </Route>
                            <Route exact path='/app/inventory/:id/history'>
                                <ItemTimeline />
                            </Route>
                            <Route exact path="/app/item-groups">
                                <ItemGroups />
                            </Route> 
                            <Route exact path="/app/printers">
                                <Printers />
                            </Route> 
                            <Route exact path="/app/tables">
                                <Tables />
                            </Route> 
                        </Switch>
                    </main>
                </div>
            </div>
            {
                lock &&
                <LockSession
                    onPerform={ resetTimer }
                    visible={ lock } />
            }
        </Receive>
    )
}

const App = () => {
    const location = useLocation()

    const { loggedIn } = useSelector(state => state.application)
    const dispatch = useDispatch()

    const [{ loading, error }] = usePet('params', {}, { notify: true, callback: ({ data }) => {
        if (data?.name) {
            document.title = `Hisani for ${data?.name}`
            dispatch(setparams(data))
        }
    }, logOutOnError: true })

    useEffect(() => {
        document.querySelector('html').style.scrollBehavior = 'auto'
        window.scroll({ top: 0 })
        document.querySelector('html').style.scrollBehavior = ''
        focusHandling('outline')
    }, [location.pathname])

    return (
        <Switch>
            <Route exact path="/">
                <Redirect to="/login" />
            </Route>
            <Route path="/login">
                <Login />
            </Route>
            <Route path="/app">
                {
                    loggedIn ?
                        <Main />
                    : <Redirect to="/login" />
                }
            </Route>
        </Switch>
    )
}

export default App
